import { useTranslation } from 'react-i18next'

const PageError = () => {
  const { t } = useTranslation()

  return (
    <div className={`mt-12 flex justify-center text-lg`}>
      {t('errors.js_error')}
    </div>
  )
}

export default PageError
